import React from 'react';

import './Button.scss';

interface IButtonPropTypes {
  label: string;
  styleKey: 'light' | 'dark' | 'form';
  width?: string | number;
  height?: string | number;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  isLoading?: boolean;
  icon?: JSX.Element;
  // Busy: the action is temporarily a no-op but the button keeps focus and stays readable, unlike `disabled`.
  isBusy?: boolean;
}
function Button({
  label,
  styleKey,
  width,
  height,
  onClick,
  disabled = false,
  className,
  isLoading = false,
  icon,
  isBusy = false,
}: Readonly<IButtonPropTypes>) {
  if (isLoading) {
    return <span className="spinner" />;
  }
  return (
    <button
      style={{ width: width ?? '', height: height ?? '' }}
      type="submit"
      value={label}
      onClick={onClick}
      className={`button ${styleKey}-button ${className}`}
      disabled={disabled}
      aria-disabled={isBusy || undefined}
      aria-busy={isBusy || undefined}
    >
      {icon} {label}
    </button>
  );
}

export default Button;
